import { cleanCmsConfigValue } from '@/lib/contentful/preview';

import type { CMSPlaceholderService, CMSSys } from '../types';

type PlaceholderServiceHeading = {
  text?: string | null;
  headingType?: string | null;
  headingSeoTag?: string | null;
  headingVariation?: string | null;
  mainColor?: string | null;
  highlightColor?: string | null;
  textAlignment?: string | null;
};

type PlaceholderServiceSource = {
  sys: { id: string; publishedAt?: string | null };
  internalName?: string | null;
  type?: string | null;
  placeholderHeading?: PlaceholderServiceHeading | null;
  subtext?: { json?: unknown } | null;
};

export function adaptPlaceholderService(
  section: PlaceholderServiceSource,
  adaptSys: (sys: PlaceholderServiceSource['sys']) => CMSSys
): CMSPlaceholderService {
  const heading = section.placeholderHeading;

  return {
    __typename: 'PlaceholderService',
    sys: adaptSys(section.sys),
    internalName: section.internalName ?? null,
    type: cleanCmsConfigValue(section.type) ?? section.type ?? null,
    placeholderHeading: heading
      ? {
          text: heading.text ?? null,
          headingType: cleanCmsConfigValue(heading.headingType) ?? heading.headingType ?? null,
          headingSeoTag:
            cleanCmsConfigValue(heading.headingSeoTag) ?? heading.headingSeoTag ?? null,
          headingVariation:
            cleanCmsConfigValue(heading.headingVariation) ?? heading.headingVariation ?? null,
          mainColor: heading.mainColor ?? null,
          highlightColor: heading.highlightColor ?? null,
          textAlignment:
            cleanCmsConfigValue(heading.textAlignment) ?? heading.textAlignment ?? null,
        }
      : null,
    subtext: section.subtext ?? null,
  };
}
